export default __webpack_public_path__ + "static/media/done.f5c991c5.png";